module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/guests_en-d6bd5a6acd765b228a2f43c949185160.webp";